module.exports = __webpack_public_path__ + "img/contact.21cf8ff5.svg";